import React, {useEffect, useState} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { useForm } from "react-hook-form"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { API_URL } from '../common/constants';
import { StyledMember, StyledPanel } from "../stylesheets/styles";
import BgComponent from '../components/BgComponent';
import Modal from 'react-bootstrap/Modal';

const Verification = () => {
  const { 
      register, 
      handleSubmit, 
      setError, 
      formState: { errors, isSubmitting }
    } = useForm({
      defaultValues: {
        Type: "register",
        otp: ''
      }
    }
  );
  const location = useLocation();
  const navigate = useNavigate();
  const { formData, result, message } = location.state || {}; // 接收從註冊頁面傳遞過來的數據
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleBackToRegister = () => {
    navigate('/register', { state: { formData } });
  };
  
  useEffect(() => {
    if (message) {
      setShowModal(true);
    }
  }, []);

  const submit = async (data) => {
    data = { ...data, SerialNo: result };
    try {
      const response = await axios.post(`${API_URL}/api/member/verifyotp`, data, {
        headers: { 'Content-Type': 'application/json' }
      });

      const { isSuccess, message } = response.data;
      if (isSuccess) {
        // 驗證成功，導航到登入頁面
        navigate('/login');
      } else {
        setError("root", {
          type: "manual",
          message: message
        });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError("root", {
          type: "manual",
          message: error.response.data.message || '驗證失敗，請稍後再試'
        });
      } else {
        setError("root", {
          type: "manual",
          message: '驗證失敗，請稍後再試'
        });
      }
    }
  }

  const handleResendOtp = async () => {
    try {
      const response = await axios.post(`${API_URL}/api/member/otp`, { SerialNo: result, Type: "register" }, {
        headers: { 
          'Content-Type': 'application/json'
        }
      });

      const { isSuccess, message } = response.data;
      if (isSuccess) {
        setShowModal(true);
      } else {
        setError("root", {
          type: "manual",
          message: message
        });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError("root", {
          type: "manual",
          message: error.response.data.message || '重新發送驗證碼失敗，請稍後再試'
        });
      } else {
        setError("root", {
          type: "manual",
          message: '重新發送驗證碼失敗，請稍後再試'
        });
      }
    }
  }
  
  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
              <StyledPanel>
                <div className="hgroup">
                  <h1 className="text-center">驗證</h1>
                </div>
                <Form noValidate onSubmit={handleSubmit(submit)}>
                  <div className="form-group mb-3">
                    <label htmlFor="otp" className="form-label">驗證碼*</label>
                    <input 
                      {...register('otp', { required: true })} 
                      type="text"
                      id="otp"
                      className={`form-control ${errors.otp ? "is-invalid" : ""}`}
                      placeholder="請輸入驗證碼"
                    />
                    {errors.otp && <p className="form-helper text-danger">請輸入驗證碼</p>}
                  </div>
                  <div className="form-button pt-4">
                    <Button disabled={isSubmitting} size="lg" variant="dark" className="w-100" type="submit">
                      { isSubmitting ? '處理中...' : '送出' }
                    </Button>
                    {errors.root && <p className="form-helper text-danger text-center mt-3">{errors.root.message}</p>}
                    <div className="d-flex align-items-center justify-content-between pt-3">
                      <Button type="button" onClick={handleBackToRegister} className="btn btn-link p-0" variant="link">更改註冊資料</Button>
                      <Button type="button" onClick={handleResendOtp} className="btn btn-link p-0 ms-auto" variant="link">請點此取得新的驗證碼</Button>
                    </div>
                  </div>
                </Form>                  
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-center w-100">OTP驗證碼已發送</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='text-center my-4' style={{maxWidth: '280px', margin: '0 auto'}}>
            {message ? message : '請進行驗證'}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            確認
          </Button>
        </Modal.Footer>
      </Modal>
    </StyledMember>
  );
};

export default Verification;
